export const LIVE_CHAT_BOTTOM_HEIGHT = '0px';
export const FEEDBACK_BOTTOM_HEIGHT = '70px';
